import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusClass',
  standalone: true
})
export class StatusClassPipe implements PipeTransform {
  private classMap: Record<string, string> = {
    'PENDING': 'status-pending',
    'APPROVED': 'status-approved',
    'REJECTED': 'status-rejected',
    'UNDER_CONSIDERATION': 'status-consideration',
    'ALLOCATED': 'status-allocated',
    'QUOTA_REVOKED': 'status-revoked'
  };

  transform(status: string): string {
    return this.classMap[status] || '';
  }
}
